import { CourseComboDiscount } from '../../types/DiscountTypes'

/** Stable key for a combo/package rule. Course order does not matter. */
export const getComboPackageKey = (pkg: Pick<CourseComboDiscount, 'courses'>): string =>
  [...pkg.courses].sort().join('|')

/**
 * A combo rule matches when every course in the rule is in the selection (extras allowed).
 * Among matches, prefer the widest rule; ties go to the larger discount.
 */
export const findBestMatchingComboRule = <T extends Pick<CourseComboDiscount, 'courses' | 'discount'>>(
  rules: T[] | undefined,
  selectedActivityIds: string[]
): T | null => {
  if (!rules?.length) return null
  const presentIds = new Set(selectedActivityIds)
  const matches = rules.filter((rule) => rule.courses.length > 0 && rule.courses.every((id) => presentIds.has(id)))
  if (matches.length === 0) return null
  return matches.reduce((best, current) =>
    current.courses.length > best.courses.length ||
    (current.courses.length === best.courses.length && current.discount > best.discount)
      ? current
      : best
  )
}
